import React, { useState } from 'react';
import { styled } from 'linaria/react';
import { default as Breadcrumbs } from '@jetshop/ui/Breadcrumbs';

const CategoryHeaderWrapper = styled('div')`
  padding: 0 20px;
  margin: 34px 0;
  text-align: center;

  h1 {
    margin: 0;
    color: #000;
    text-align: center;
    font-family: Lato;
    font-size: 40px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: uppercase;
    margin-bottom: 24px;
  }
`;

const StyledBreadcrumbs = styled(Breadcrumbs)`
  margin: 0;
  padding: 0;
  text-align: center;
  justify-content: center;
  color: #494949;
  font-family: Lato;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 10px;

  a {
    text-decoration: none;
  }
`;

const CategoryText = styled('div')`
  max-width: 32rem;
  margin: 0 auto;
  color: #000;
  text-align: center;
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%; /* 22.4px */

  span {
    color: #000;
    cursor: pointer;
    text-decoration: underline;
    text-underline-position: under;
  }
`;

export const CategoryHeader = ({ parents, breadcrumbText, title, content }) => {
  const [readMore, setReadMore] = useState(false);
  const breadcrumbProps = {
    breadcrumbText: breadcrumbText,
    parents,
  };

  return (
    <CategoryHeaderWrapper>
      <StyledBreadcrumbs {...breadcrumbProps} />
      <h1>{title}</h1>
      {content && (
        <CategoryText
          onClick={() => setReadMore(!readMore)}
          dangerouslySetInnerHTML={{
            __html: readMore
              ? content +
                ' <span class="read-more">' +
                'Läs mindre' +
                '</span> '
              : content.slice(0, 220) +
                '... <span class="read-more">' +
                'Läs mer' +
                '</span>',
          }}
        />
      )}
    </CategoryHeaderWrapper>
  );
};
